<template>
	<van-nav-bar left-arrow>
		<template #left>
			<img width="28px" height="28px" src="~@/assets/img/nav/back.png" alt="" @click="goBack(1)">
		</template>
		<template #title>
			<div class="content">
				个人中心
			</div>
		</template>
		<template #right>
			<img width="28px" height="28px" src="~@/assets/img/backTop/cate-home.png" alt="" @click="goBack(2)">
		</template>
	</van-nav-bar>
</template>

<script>
	import {
		Toast
	} from 'vant'
	export default {
		name: 'TopNavBar',
		data() {
			return {
				searchName: ''
			}
		},
		methods: {
			goBack(type) {
				switch (type) {
					case 1:
						this.$router.go(-1)
						break
					case 2:
						this.$router.push({
							name: 'Home',
							query: {
								shopUuid: this.$store.state.shopUuid
							}
						})
						break
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	.home-logo {
		height: 30px;
		margin-top: 8px;
	}

	.home-left,
	.home-right {
		width: 29px;
		height: 29px;
	}

	.content {
		font-size: 18px;
		font-family: PingFang SC;
		font-weight: bold;
		color: #323232;
	}
</style>
